import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type EmailType as SchemaEmailType } from '../schemas/EmailType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const SendTestMessageContentType = 'application/json' as const;
export type SendTestMessageRequest = {
    recipient: string;
    email_type: SchemaEmailType;
};
export type SendTestMessageResponses = LinkCommonErrorResponses & {
    '200': {};
};
export type SendTestMessageResponseSuccess = undefined;
export type SendTestMessageSearchParams = undefined;
export type SendTestMessagePathParameters = undefined;
export const SendTestMessageUrl = '/email/send_test_message' as const;
export const SendTestMessageMethod = 'POST' as const;
export const getSendTestMessageUrl = (_params?: SendTestMessagePathParameters) => SendTestMessageUrl;
